export const NumberCheck = (value:string) => {
  const newValue = value.replace(/[^0-9]/g,"");
  return newValue;
}